import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { HomePageActions } from "../Store/Home/action";
import { useNavigate, useLocation } from "react-router-dom";

const HeaderBackground = ({
  menuName,
  subMenuName,
  thirdLevelName,
  handleMenuToggle,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    dispatch({ type: HomePageActions.GET_SEO_IMAGE });
  }, [dispatch]);

  const { SeoImage } = useSelector((state) => state.HomePageReducer);
  const backgroundImageUrl = SeoImage?.[0]?.image || "";

  // 🧭 Dynamic breadcrumbs based on route
  const getBreadcrumbItems = () => {
    const breadcrumbs = [
      { label: "Home", onClick: () => navigate("/") },
    ];

    if (menuName) {
      breadcrumbs.push({
        label: menuName,
        onClick: handleMenuToggle,
      });
    }

    if (subMenuName) {
      breadcrumbs.push({
        label: subMenuName,
        onClick: () => navigate("/about-us/statutory-committee"),
      });
    }

    if (thirdLevelName) {
      breadcrumbs.push({ label: thirdLevelName });
    }

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbItems();

  return (
    <header
      className="page-header-cerv bg-img bg-center section-padding"
      style={{ backgroundImage: `url(${backgroundImageUrl})` }}
      data-overlay-dark="4"
    >
      <div className="container pt-100 ontop">
        <div className="text-left text-white">
          {breadcrumbs.map((crumb, index) => (
            <span key={index}>
              {index > 0 && <span className="padding-rl-10">|</span>}
              {crumb.onClick ? (
                <button
                  onClick={crumb.onClick}
                  style={{
                    cursor: "pointer",
                    background: "none",
                    border: "none",
                    padding: 0,
                    color: "white",
                  }}
                >
                  {crumb.label}
                </button>
              ) : (
                <span>{crumb.label}</span>
              )}
            </span>
          ))}
        </div>
      </div>
    </header>
  );
};

export default HeaderBackground;

